import BreadCrumb from "Components/Common/BreadCrumb";
import { useLocation } from "react-router-dom";
import { usePageActivity } from "Components/Hooks/UsePageActivity";
import React, { useState } from "react";
import { Card, CardBody, Col, Container, Row } from "reactstrap";
import ActivityReportWidgets from "./ActivityReportWidgets";
import ActiveUserStats from "./ActiveUserStats";
import TopPages from "./TopPages";
import MostViewedContent from "./MostViewedContent";
import EngagementSummary from "./EngagementSummary";
import ActivityHeatmap from "./ActivityHeatmap";
import AgencyEngagement from "./AgencyEngagement";
import TopUsers from "./TopUsers";

const PERIODS = [
  { key: "pastweek", label: "Last 7 days" },
  { key: "pastmonth", label: "Last 30 days" },
  { key: "past6months", label: "Last 6 months" },
  { key: "pastyear", label: "Last year" },
  { key: "all", label: "All time" },
];

const OldActivityReport = () => {
  const location = useLocation();
  usePageActivity(location.pathname, "Old Activity Report");

  // Shared across the newer widgets so the whole report moves together.
  const [typeOfRequest, setTypeOfRequest] = useState<string>("pastmonth");

  return (
    <React.Fragment>
      <div className="page-content">
        <Container fluid>
          <BreadCrumb
            title="Old Activity Report"
            pageTitles={[
              { title: "Dashboard", link: "/dashboard" },
              { title: "User Activity", link: "#" },
            ]}
          />

          <Row>
            <Col xs={12}>
              <Card>
                <CardBody className="d-flex align-items-center flex-wrap gap-2">
                  <div className="flex-grow-1">
                    <h5 className="card-title mb-1">Engagement Overview</h5>
                    <p className="text-muted mb-0 fs-13">
                      Compares the selected period against the preceding period
                      of the same length.
                    </p>
                  </div>
                  <div className="d-flex flex-wrap gap-1">
                    {PERIODS.map((period) => (
                      <button
                        key={period.key}
                        type="button"
                        className={`btn btn-sm material-shadow-none ${
                          typeOfRequest === period.key
                            ? "btn-soft-primary"
                            : "btn-soft-secondary"
                        }`}
                        onClick={() => setTypeOfRequest(period.key)}
                      >
                        {period.label}
                      </button>
                    ))}
                  </div>
                </CardBody>
              </Card>
            </Col>
          </Row>

          <Row>
            <EngagementSummary typeOfRequest={typeOfRequest} />
          </Row>

          <Row>
            <ActivityHeatmap typeOfRequest={typeOfRequest} />
          </Row>

          <Row>
            <AgencyEngagement typeOfRequest={typeOfRequest} />
            <TopUsers typeOfRequest={typeOfRequest} />
          </Row>

          <Row>
            <ActivityReportWidgets />
          </Row>

          <Row>
            <ActiveUserStats />
            <TopPages typeOfRequest={typeOfRequest} />
          </Row>

          <Row>
            <MostViewedContent />
          </Row>
        </Container>
      </div>
    </React.Fragment>
  );
};

export default OldActivityReport;
